import { createSlice, CaseReducer, PayloadAction } from '@reduxjs/toolkit';

import { get, del, put } from 'api/requests';

import { updateDistribution } from 'pages/Timesheet/slices/loadingOvp/distributionSlice';

import { AppThunk } from 'store/types';
import { IParamsReq, ITaskData } from 'types';
import { ITimeItem } from 'pages/Timesheet/TimesheetApartments/types';

interface ICalendarStore {
  list: ITimeItem[];
  loading: boolean;
}

const initialState: ICalendarStore = {
  list: [],
  loading: false,
};

const reset: CaseReducer<ICalendarStore> = () => initialState;

const loading: CaseReducer<ICalendarStore, PayloadAction<boolean>> = (state, action) => {
  state.loading = action.payload;
};

const list: CaseReducer<ICalendarStore, PayloadAction<ITimeItem[]>> = (state, action) => {
  state.list = action.payload;
};

export const calendarSlice = createSlice({
  name: 'OVP/calendar', // TODO нэиминг
  initialState,
  reducers: {
    reset,
    loading,
    list,
  },
});

const { reset: setReset, loading: setLoading, list: setCalendar } = calendarSlice.actions;

const fetchCalendar =
  (search: IParamsReq, date?: string): AppThunk =>
  dispatch => {
    const { project, ...params } = search;

    dispatch(setLoading(true));

    get<ITimeItem[]>(
      `/api/timesheet/schedule/project/${project}/`,
      date ? { date: date, ...params } : params,
    )
      .then(({ data }) => {
        dispatch(setCalendar(data));
      })
      .finally(() => dispatch(setLoading(false)));
  };

export const removeCalendar =
  (task: ITaskData & { parentId: string }, search: IParamsReq): AppThunk =>
  (dispatch, getState) => {
    const { timesheet } = getState();
    const { loadingOvp } = timesheet;
    const { key: date } = loadingOvp.date.currentDate;
    const { project } = search;

    del(`/api/timesheet/scs/${task.id}/`)
      .then(() => {
        dispatch(updateDistribution(Number(project)));

        if (project && date) {
          dispatch(fetchCalendar(search, date));
        }
      })
      .finally(() => dispatch(setLoading(false)));
  };

export const updateCalendar =
  (search: IParamsReq): AppThunk =>
  (dispatch, getState) => {
    const { timesheet } = getState();
    const { loadingOvp } = timesheet;
    const { key: date } = loadingOvp.date.currentDate;
    const { project } = search;

    if (project && date) {
      dispatch(fetchCalendar(search, date));
    }
  };

export const getCalendar =
  (search: IParamsReq, date: string): AppThunk =>
  dispatch => {
    dispatch(fetchCalendar(search, date));
  };

export const rescheduleCalendar =
  (search: IParamsReq, { date, id }: { date: string; id: string }): AppThunk =>
  dispatch => {
    const { project } = search;

    dispatch(setLoading(true));

    put(`/api/timesheet/izs-appointments/${id}/edit-date/`, { date })
      .then(() => {
        dispatch(updateCalendar(search));
        dispatch(updateDistribution(Number(project)));
      })
      .finally(() => dispatch(setLoading(false)));
  };

export { setReset, setCalendar };
